import React from 'react';
import Media from 'react-media';
import Cookies from 'universal-cookie';
import ItemsCarousel from 'react-items-carousel';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import {CircularProgress} from "@material-ui/core";
// import TagManager from 'react-gtm-module';

// childrens
import ProdutoCard from '../childrens/.mixins/ProdutoCard'

// controllers
import Produtos_controller from '../../../../../../../../controllers/produtos';

function Cards(props) {
  const {
    activeItemIndex,
    children,
  } = props.state;
  return (
    <Media query="(min-width: 1200px)">
        {matches =>
        matches ? (
            <ItemsCarousel
                // Placeholder configurations
                enablePlaceholder
                numberOfPlaceholderItems={props.state.children}
                minimumPlaceholderTime={1000}
                placeholderItem={<ProdutoCard/>}
        
                // Carousel configurations
                numberOfCards={3}
                gutter={12}
                showSlither={true}
                firstAndLastGutter={true}
                freeScrolling={false}
        
                // Active item configurations
                requestToChangeActive={props.changeActiveItem}
                activeItemIndex={activeItemIndex}
                activePosition={'center'}
        
                chevronWidth={24}
                rightChevron={<KeyboardArrowRight/>}
                leftChevron={<KeyboardArrowLeft/>}
                outsideChevron={false}
                >
                {children}
            </ItemsCarousel>
        ) : (
            <ItemsCarousel
                // Placeholder configurations
                enablePlaceholder
                numberOfPlaceholderItems={props.state.children}
                minimumPlaceholderTime={1000}
                placeholderItem={<ProdutoCard/>}
        
                // Carousel configurations
                numberOfCards={1}
                gutter={12}
                showSlither={true}
                firstAndLastGutter={true}
                freeScrolling={false}
        
                // Active item configurations
                requestToChangeActive={props.changeActiveItem}
                activeItemIndex={activeItemIndex}
                activePosition={'center'}
        
                chevronWidth={24}
                rightChevron={<KeyboardArrowRight/>}
                leftChevron={<KeyboardArrowLeft/>}
                outsideChevron={false}
                >
                {children}
            </ItemsCarousel>
        )
        }
    </Media>
  );  
}

export default class CotacoesLista extends React.Component {

    constructor(props) {
      super(props);
      
      this.state = {
        children: null,
        activeItemIndex: 0,
        isLoading: true,
        itens: null
      };

      this.loadProdutos(this);
    }
  
    createChildren = n => n.map((item,i) => <ProdutoCard key={i} value={item}/>);
  
    changeActiveItem = (activeItemIndex) => this.setState({ activeItemIndex });

    async loadProdutos(props) {
      
        const cookies = new Cookies();
        var json = JSON.parse(await Produtos_controller.getProdutos(cookies.get('User-Token')));
        if (json.status) {

          await this.setState({
            itens: json.itens,
            isLoading: false,
            children: this.createChildren(json.itens),
          });

          // TagManager.dataLayer({
          //   dataLayer: {
          //     event: 'event',
          //     eventCategory: 'tokstok:fornecedores:cotacoes',
          //     eventAction: 'callback',
          //     eventLabel: 'sucesso:lista-produtos',
          //   }
          // });

        } else {
          const erroString = 'Erro ao carregar dados!';
          props.child.current.retorno(erroString,'error');

          // TagManager.dataLayer({
          //   dataLayer: {
          //     event: 'event',
          //     eventCategory: 'tokstok:fornecedores:cotacoes',
          //     eventAction: 'callback',
          //     eventLabel: `erro:${erroString}`,
          //   }
          // });
        }

    }

    render() {
      return(
        <div>
          {this.state.isLoading ? (
            <CircularProgress/>
          ) : (
            <Cards {...this}/>
          )}
        </div>
      );
    }
  }